// Pull-to-refresh (phone). The app scrolls INSIDE .charlie-main-content, not the window, so the old check (window.scrollY === 0) was always true and any downward drag of about 140px
// (flicking back up a long list) hard-reloaded the app. Now it arms only when the touch starts with the main content AND every scrolling parent of the touched element at the very top,
// and a pull never reloads by itself: it asks first (a reload loses unsaved work on the screen).
export const THRESHOLD = 70;

export function atVeryTop(target, doc = document) {
  const main = doc.querySelector('.charlie-main-content');
  if (main && main.scrollTop > 0) return false;
  if ((doc.defaultView && doc.defaultView.scrollY) > 0) return false;
  for (let el = target; el && el !== doc.body && el !== main; el = el.parentElement) {
    if (el.scrollTop > 0) return false; // a list, table or panel scrolled down inside the page
  }
  return true;
}

export function confirmRefresh(win = window) {
  return win.confirm('Refresh Charlie? Anything you have not saved on this screen will be lost.');
}
